export default __webpack_public_path__ + "static/media/synesthesia.c5a2f830.png";